import { ExistingSnapshotPage } from 'app/features/DiscoverySettingsForms/pages/ExistingSnapshotPage';
import { NewSnapshotPage } from 'app/features/DiscoverySettingsForms/pages/NewSnapshotPage';
import { ModalFullContent } from 'components/ModalFullContent/ModalFullContent';
import {
  makeSelectDiscoveryRunByUser,
  makeSelectDiscoveryStarting,
} from 'containers/App/Header/JobManagement/selectors';
import { makeSelectDisableStartBtn } from 'pages/SnapshotManagement/selectors';
import type { Snapshot } from 'pages/SnapshotManagement/snapshotManagementTypes';
import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';

interface Props {
  foundSnapshot?: Snapshot;
  newSnapshot: boolean;
  onClose: () => void;
  onSettingsSaved?: () => void;
  showSettings: boolean;
}

interface SnapshotsSelector {
  discoveryRunByUser: boolean;
  discoveryStarting: boolean;
  startButtonSystemDisabled: boolean;
}

const snapshotsSelector = createStructuredSelector({
  discoveryRunByUser: makeSelectDiscoveryRunByUser(),
  discoveryStarting: makeSelectDiscoveryStarting(),
  startButtonSystemDisabled: makeSelectDisableStartBtn(),
});

const SNAPSHOT_SETTINGS_WRAPPER_CLASSNAME =
  'inset-0 z-10 flex flex-1 flex-col overflow-auto absolute';

export const SettingsPage: FC<Props> = (props) => {
  const { discoveryRunByUser, discoveryStarting, startButtonSystemDisabled } =
    useSelector<unknown, SnapshotsSelector>(snapshotsSelector);

  if (!props.showSettings) {
    return null;
  }

  const saveButtonDisabled =
    discoveryStarting || startButtonSystemDisabled || discoveryRunByUser;

  if (props.foundSnapshot === undefined || props.newSnapshot) {
    return (
      <ModalFullContent>
        <div className={SNAPSHOT_SETTINGS_WRAPPER_CLASSNAME}>
          <NewSnapshotPage
            saveButtonDisabled={saveButtonDisabled}
            onClose={props.onClose}
          />
        </div>
      </ModalFullContent>
    );
  }
  return (
    <ModalFullContent>
      <div className={SNAPSHOT_SETTINGS_WRAPPER_CLASSNAME}>
        <ExistingSnapshotPage
          saveButtonDisabled={saveButtonDisabled}
          snapshot={props.foundSnapshot as Snapshot}
          onClose={props.onClose}
          onSettingsSaved={props.onSettingsSaved}
        />
      </div>
    </ModalFullContent>
  );
};
